// Images for the Polish landing. Gallery pages are real pages of the Polish PDF (public Drive files).
export interface GalleryItem {
  title: string
  caption: string
  image: string
}

const drivePage = (id: string) => `https://lh3.googleusercontent.com/d/${id}=w1200-rw`

export const gallery: GalleryItem[] = [
  {
    title: 'Przysiad ze sztangą',
    caption:
      'Mięśnie główne, stabilizatory, płaszczyzna anatomiczna i najczęstsze błędy — wszystko na jednej mapie.',
    image: drivePage('18DSGprC51LEJLWI_CrO333yYlPrx2NQM'),
  },
  {
    title: 'Przysiad bułgarski',
    caption: 'Praca jednostronna: co stabilizuje, co kompensuje i jak to skorygować.',
    image: drivePage('1CGmy6cMRCL1ULHbibOUjQ4GuOSA8vBT_'),
  },
  {
    title: 'Wyciskanie sztangi na ławce skośnej',
    caption:
      'Część obojczykowa mięśnia piersiowego, stożek rotatorów i prawidłowy tor sztangi.',
    image: drivePage('1sN6RO0hJFXytVtFIn01kFibJSqjwoK07'),
  },
  {
    title: 'Rozpiętki na bramie z górnych wyciągów',
    caption:
      'Przywodzenie poziome w płaszczyźnie poprzecznej i kontrola napięcia mięśnia piersiowego.',
    image: drivePage('1Zfbi3Kiv44eznFzM129bQ3yE_6xcRcA1'),
  },
  {
    title: 'Wiosłowanie sztangą',
    caption: 'Retrakcja łopatek, łańcuch tylny i dlaczego bujanie ciałem psuje ćwiczenie.',
    image: drivePage('1o4BT78DB8TYf8v5tDHIq-0RuRkKwJ8-a'),
  },
]

// Polish mockup approved by Lucas (MOCKUP_PL.png in the Drive folder), served as JPEG to keep it light.
export const heroImage = 'https://lh3.googleusercontent.com/d/1MCcnUV4B1Gm8TonzYFNiPb6xltCWnbkT=w1254-rj'
